import { Component, ElementRef, ViewChild, OnInit, OnDestroy, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ModalEditTechnicianTaskComponent } from 'src/app/components/modals/modal-edit-technician-task.component';
import { FullFilterComponent } from 'src/app/components/offcanvas/full-filter.component';
import { OffcanvasTasksComponent } from 'src/app/components/offcanvas/offcanvas-tasks.component';
import { Building } from 'src/app/models/building.model';
import { Settlement } from 'src/app/models/settlement.model';
import { Task } from 'src/app/models/task.model';
import { User } from 'src/app/models/user';
import { SettlementsService } from 'src/app/services/settlements.service';
import { TasksService } from 'src/app/services/tasks.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DateService } from 'src/app/shared/services/date.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { GodModeService } from 'src/app/shared/services/god-mode.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { Subscription } from 'rxjs';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-task-index',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tasks [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Tareas</h2>
          </div>
        </div>
        <div class="d-flex">
          <div>
            <div ngbDropdown class="d-inline-block">
              <button type="button" 
                class="btn btn-zazz-default rounded-4 px-4 shadow-sm" 
                id="dropdownForm1" 
                ngbDropdownToggle>
                <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                Este mes
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;" (click)="$event.stopPropagation()">
                <div class="row">
                  <div class="col-3">
                    <ul class="list-group calendar-list-group ps-2 mt-2">
                      <li #1day class="list-group-item list-group-item-action active" (click)="updateFilter(1)">Hoy</li>
                      <li #yesterday class="list-group-item list-group-item-action" (click)="updateFilter(0)">Ayer</li>
                      <li #1mes class="list-group-item list-group-item-action" (click)="updateFilter(1)">Este mes</li>
                      <li #3mes class="list-group-item list-group-item-action" (click)="updateFilter(3)">3 meses</li>
                      <li #6mes class="list-group-item list-group-item-action" (click)="updateFilter(6)">6 meses</li>
                      <li #12mes class="list-group-item list-group-item-action" (click)="updateFilter(12)">12 meses</li>
                      <li #custom class="list-group-item list-group-item-action">Personalizado</li>
                    </ul>
                  </div>
                  <div class="col-9" style="height: 320px;">
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input
                        #dpFromDate
                        class="form-control"
                        style="width: 0px !important; height: 0px !important; opacity: 0;"
                        ngbDatepicker
                        #datepicker="ngbDatepicker"
                        [autoClose]="false"
                        (dateSelect)="onDateSelection($event)"
                        [displayMonths]="2"
                        [dayTemplate]="t"
                        outsideDays="hidden"
                        [startDate]="fromDate!"
                        tabindex="-1" 
                      />
                      <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.selected]="date.equals(fromDate) || (toDate && date.equals(toDate))"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-fill">
            <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
              <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
              Filtrar búsqueda
            </button>
          </div>
          <div class="flex-fill ms-3 me-3 text-end">
            <button class="btn btn-zazz-dark" *ngIf="authService.hasPermission('can_create_tasks')" routerLink="create">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar tarea
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"># Tarea</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Técnico</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Condominio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Creada</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Programada</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Completada</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-task
                  [task]="task"
                  [builders]="builders"
                  [profile]="profile"
                  [technicians]="technicians"
                  [settlements]="settlements"
                  (taskData)="destroyTask($event)"
                  (editTask)="editTask($event)"
                  *ngFor="let task of tasks | paginate: { itemsPerPage: taskFilterPrefs.per_page, currentPage: p, totalItems: meta.total_entries }"
                ></tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="tasks.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="tasks.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted text-center">No se encontraron registros</p>
            </div>
            <div class="list-group-item text-center pt-3">
              <pagination-controls
                (pageChange)="onPageChange($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-edit-technician-task
      [task]="selectedTask"
      [technicians]="technicians"
      *ngIf="authService.hasPermission('can_edit_tasks')"
    ></app-modal-edit-technician-task>
  `,
  styleUrls: []
})
export class TaskIndexComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  tasks: Task[] = [];
  meta: any = {};
  godmode: boolean = false;

  @ViewChild(ModalEditTechnicianTaskComponent, { static: true }) modalEditTechnicianTask!: ModalEditTechnicianTaskComponent;
  @ViewChild('1day') oneDay !: ElementRef;
  @ViewChild('yesterday') yesterday !: ElementRef;
  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;
  @ViewChild('custom') custom !: ElementRef;
  @ViewChild('datepicker') datepicker: any;
  
  settlements: Settlement[] = [];
  buildings: Building[] = [];
  builders: any = [];
  technicians: User[] = [];

  searchActive: boolean = false;
  currentView: string = 'tasks';
  hoveredDate: NgbDate | null = null;

  selectedTask: Task | null = null;

  profile: any = {};
  searchBox: FormGroup = new FormGroup({});

  payload: any = {
    page: 1,
    per_page: 50,
  };

  status: any = [
    { id: 1, name: 'Pendiente' },
    { id: 2, name: 'En proceso' },
    { id: 3, name: 'Completada' },
    { id: 4, name: 'Cancelada' },
  ];

  p: number = 1;

  taskFilterPrefs: any = {};

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate: NgbDate | null;

  private godModeSubscription: Subscription = new Subscription();
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private taskService: TasksService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private breadcrumbService: BreadcrumbService,
    private dateService: DateService,
    private godModeService: GodModeService,
    private offcanvasService: NgbOffcanvas,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.godmode = this.godModeService.getGodMode();
    this.payload.profile_id = this.profile.id;

    const today = new Date();
    today.setMonth(today.getMonth() - 12);
    const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const testDate = new Date(this.a.getFullYear(), 1, 15); // February 15, 2025 (months are 0-indexed)
    const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

    this.taskFilterPrefs = this.storageService.getItem(STORAGE_KEYS.TASKFILTERPREFS) ? this.storageService.getItem(STORAGE_KEYS.TASKFILTERPREFS) : this.payload;
    
    // Ensure essential pagination properties are set
    this.taskFilterPrefs.page = this.taskFilterPrefs.page || 1;
    this.taskFilterPrefs.per_page = this.taskFilterPrefs.per_page || 50;
    
    // Set initial date range
    this.taskFilterPrefs.created_at_since = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
    this.taskFilterPrefs.created_at_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;
    
    // Set profile_id based on god mode state
    if (!this.godmode) {
      this.taskFilterPrefs.profile_id = this.profile.id;
    } else {
      delete this.taskFilterPrefs.profile_id;
    }
  }

  // Add this method to handle dropdown clicks
  onDropdownClick(event: Event) {
    event.stopPropagation();
  }

  ngOnInit(): void {
    // Synchronize pagination state
    this.p = this.taskFilterPrefs.page || 1;
    
    // Subscribe to god mode changes
    this.godModeSubscription = this.godModeService.godMode$.subscribe(
      (godMode: boolean) => {
        this.godmode = godMode;
        // Update taskFilterPrefs based on god mode
        if (!this.godmode) {
          this.taskFilterPrefs.profile_id = this.profile.id;
        } else {
          delete this.taskFilterPrefs.profile_id;
        }
        // Reload tasks when god mode changes
        this.loadTasks(this.taskFilterPrefs);
      }
    );

    this.loadTasks(this.taskFilterPrefs);
    this.initForm();
    this.breadcrumbService.set('@index', 'Servicio técnico');
    this.breadcrumbService.set('@tasks', 'Tareas');

    this.loadTechnicians();
    this.loadSettlements();
    // this.loadTaskCategories();

    setTimeout(() => {
      this.datepicker.open();
    });
  }

  ngOnDestroy(): void {
    this.godModeSubscription.unsubscribe();
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    });
  }

  loadSettlements() {
    let settlementPayload: any = {
      page: 1,
      per_page: 1000,
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      console.log("Settlements: ", data);
      this.settlements = data.data;
    });
  }

  loadTechnicians() {
    this.store.getUsers({ page: 1, per_page: 100, role_id: 3 }).subscribe((data: any) => {
      this.technicians = data.data;
    });
  }

  searchTasks(event: any) {
    this.taskFilterPrefs.page = 1;
    this.taskFilterPrefs.name = this.searchBox.value.search;
    this.loadTasks(this.taskFilterPrefs);
  }

  loadTasks(payload: any) {
    this.loading = true;
    console.log("Loading tasks with payload:", payload);
    this.taskService.getTasks(payload).subscribe({
      next: (tasks: any) => {
        console.log("Tasks response:", tasks.data);
        console.log("Meta pagination info:", tasks.meta);
        console.log("Total entries:", tasks.meta?.total_entries);
        console.log("Current page:", tasks.meta?.current_page);
        console.log("Total pages:", tasks.meta?.total_pages);
        this.tasks = tasks.data;
        this.meta = tasks.meta;
        this.loading = false;      
      }, error: (err: any) => {
        console.log(err);
        this.toastr.error(err.error.message, 'Error');
        this.loading = false;
      }
    });
  }

  selectSettlement(event: any) {
    let buildingPayload: any = {
      page: 1,
      per_page: 50,
      settlement_id: event.target.value
    };
    
    // this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      // this.buildings = data.data;      
    // });

    this.searchActive = true;
    this.taskFilterPrefs.settlement_id = event.target.value;
    this.loadTasks(this.taskFilterPrefs);
  }

  selectBuilding(event: any) {

    this.taskFilterPrefs.building_id = event.target.value;
    this.loadTasks(this.taskFilterPrefs);
    this.searchActive = true;
  }

  updateFilter(mes: number) {

    setTimeout(() => {
      this.datepicker.open();
    });

    if (mes === 0) {
      // Handle yesterday
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      
      this.fromDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      this.toDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      
      // Update active states
      this.oneDay.nativeElement.classList.remove('active');
      this.yesterday.nativeElement.classList.add('active');
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
      this.custom.nativeElement.classList.remove('active');
    } else {
      const today = new Date();
      today.setMonth(today.getMonth() - mes);
      const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const testDate = new Date(this.a.getFullYear(), 1, 15); // February 15, 2025 (months are 0-indexed)
      const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

      this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
      this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

      this.taskFilterPrefs.created_at_since = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      this.taskFilterPrefs.created_at_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;

      this.loadTasks(this.taskFilterPrefs);

      if (mes == 1) {
        this.oneMonth.nativeElement.classList.add('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 3) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.add('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 6) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.add('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 12) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.add('active');
        this.custom.nativeElement.classList.remove('active');
      }
    }
  }

  clearFilter() {
    this.taskFilterPrefs = {
      page: 1,
      per_page: 50,
    };
    
    // Respect god mode state when clearing filters
    if (!this.godmode) {
      this.taskFilterPrefs.profile_id = this.profile.id;
    } else {
      delete this.taskFilterPrefs.profile_id;
    }
    
    this.settlements = [];
    this.loadSettlements();
    this.buildings = [];
    this.technicians = [];
    this.loadTechnicians();
    // this.taskCategories = [];
    // this.loadTaskCategories();
    this.searchActive = false;
    this.loadTasks(this.taskFilterPrefs);
  }

  pageChanged(event: any) {
    this.taskFilterPrefs.page = event;
    this.storageService.saveItem(STORAGE_KEYS.TASKFILTERPREFS, this.taskFilterPrefs);
    this.loadTasks(this.taskFilterPrefs);
  }

  onPageChange(event: any) {
    this.p = event;
    this.pageChanged(event);
  }

  destroyTask(event: any) {
    this.taskService.cancelTask(event.id).subscribe({
      next: (resp: any) => {
        console.log(resp);
        window.location.reload();
        this.toastr.success(resp.message, 'Éxito');        
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(err.error.message, 'Error');
      },
    });
    this.loadTasks(this.taskFilterPrefs);
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && 
      !this.toDate && 
      this.hoveredDate && 
      date.after(this.fromDate) && 
      date.before(this.hoveredDate)
    );
  }

    isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && 
          date.after(this.fromDate) && 
          date.before(this.toDate);
  }

  editTask(task: any) {
    console.log('Editing task:', this.modalEditTechnicianTask, task);
    this.selectedTask = task;
    const modalTemplate: any | undefined = this.modalEditTechnicianTask;
    if (modalTemplate) {
      // modalTemplate.task = task;
      // modalTemplate.technicians = this.technicians;
      modalTemplate.modalEditTechnicianTask.open();
    } else {
      console.error('ModalEditTechnicianTaskComponent not found');
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      if (this.fromDate.after(this.toDate)) {
        // If fromDate is after toDate, swap them
        const temp = this.fromDate;
        this.fromDate = this.toDate;
        this.toDate = temp;
      }
		} else {
			this.toDate = null;
			this.fromDate = date;
		}

    if (this.fromDate && this.toDate) {
      this.taskFilterPrefs.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      this.taskFilterPrefs.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
      this.storageService.saveItem(STORAGE_KEYS.TASKFILTERPREFS, this.taskFilterPrefs);
      this.loadTasks(this.taskFilterPrefs);
    }
  }

  openFilters() {
    const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
      position: 'end',
      animation: true,
      backdrop: true,
      keyboard: true,
      scroll: true,
      backdropClass: 'bg-dark',
      panelClass: 'bg-light',
    });

    offcanvasRef.componentInstance.payload = this.taskFilterPrefs;
    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.result.then((result: any) => {
      console.log('result => ', result);
      this.taskFilterPrefs = result;
      
      // Respect god mode state when applying filters
      if (!this.godmode) {
        this.taskFilterPrefs.profile_id = this.profile.id;
      } else {
        delete this.taskFilterPrefs.profile_id;
      }
      
      this.loadTasks(this.taskFilterPrefs);
    });
  }
}
